import { DEBOUNCE_TIME } from '@innovyze/stylovyze/lib/utils/constants';
import { useCallback, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
export default function useSearchDebouncedEvents({ onDebounceChange, onChange, debounceTime, }) {
    const [isDebouncing, setIsDebouncing] = useState(false);
    const handleDebounceChange = useDebouncedCallback((e) => {
        if (onDebounceChange) {
            onDebounceChange(e);
            setIsDebouncing(false);
        }
    }, debounceTime ?? DEBOUNCE_TIME);
    const combinedHandleChange = (e) => {
        e.persist();
        if (onChange)
            onChange(e);
        if (onDebounceChange) {
            setIsDebouncing(true);
            handleDebounceChange.callback(e);
        }
    };
    const callbackCombinedHandleChange = useCallback(combinedHandleChange, [
        handleDebounceChange,
    ]);
    return { onChange: callbackCombinedHandleChange, isDebouncing };
}
